export default __webpack_public_path__ + "static/blogThumbnail(1)-0e68a91c41274ce46df4e6bf44b0f63e.png";